module.exports = __webpack_public_path__ + "static/media/listCaixa.050b6e72.png";